/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Create_TitleInputs */

const cs_task_create_title = /** @type {(inputs: Task_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový úkol`)
};

const en_task_create_title = /** @type {(inputs: Task_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New task`)
};

/**
* | output |
* | --- |
* | "New task" |
*
* @param {Task_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const task_create_title = /** @type {((inputs?: Task_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_create_title(inputs)
	return cs_task_create_title(inputs)
});